// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hfH65e2W0mUfAHl9udrP{width:100%;position:relative;overflow-x:clip}.hfH65e2W0mUfAHl9udrP .recharts-wrapper{height:319px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `hfH65e2W0mUfAHl9udrP`
};
export default ___CSS_LOADER_EXPORT___;
